import Components from "slotworks/components/components";
import { SoundEvent } from "slotworks/sound/sound-events";
import SoundManager from "slotworks/sound/sound-manager";
import Timer from "slotworks/utils/timer";
import * as TweenJS from "slotworks/utils/tween";

let pendingUpdate: number;
let totalWinTween: TweenJS.Tween;
let currentWinTween: TweenJS.Tween;
const tickingValues = {totalWin: 0, currentWin: 0};
const targetValues = {totalWin: 0, currentWin: 0};

export function SetWinningsCommand(currentWin: number, totalWin?: number, delay: number = 0, tickTime: number = 0) {
    // Clear any delayed updates
    Timer.clearTimeout(pendingUpdate);

    if (delay > 0) {
        // If there is a delay, run this function again after the delay
        pendingUpdate = Timer.setTimeout(() => SetWinningsCommand(currentWin, totalWin, 0, tickTime), delay);
    } else {
        if (totalWin === undefined) {
            totalWin = currentWin;
        }

        // Count how many updates are necessary (in case some are already ticking up)
        let outstandingUpdates = 2;

        // Stop total tick up if value has changed,
        // or if it is already ticking to correct value,
        // mark this update as complete already
        if (totalWinTween) {
            if (totalWin !== null && totalWin !== targetValues.totalWin) {
                totalWinTween.stop();
            } else {
                outstandingUpdates--;
            }
        }
        // As above but with current win
        if (currentWinTween) {
            if (currentWin !== targetValues.currentWin) {
                currentWinTween.stop();
                SoundManager.event(SoundEvent.winnings_countup_end);
            } else {
                outstandingUpdates--;
            }
        }

        // If both fields are already ticking to desired values, this update is moot
        if (outstandingUpdates < 1) {
            return;
        }

        // If the values are to be ticked up
        if (tickTime > 0) {
            // Reset current win to 0, but keep last total win
            tickingValues.currentWin = 0;

            // Only update total if it isn't null
            if (totalWin !== null) {
                targetValues.totalWin = totalWin;
                totalWinTween = new TweenJS.Tween(tickingValues)
                    .to({totalWin}, tickTime)
                    .onUpdate(updateTotalWin)
                    .start();
            }
            targetValues.currentWin = currentWin;
            SoundManager.event(SoundEvent.winnings_countup);
            currentWinTween = new TweenJS.Tween(tickingValues)
                .to({currentWin}, tickTime)
                .onUpdate(updateCurrentWin)
                .onComplete(() => {
                    SoundManager.event(SoundEvent.winnings_countup_end);
                })
                .start();
        } else {
            // Values are to be instantly set
            tickingValues.totalWin = totalWin;
            tickingValues.currentWin = currentWin;
            targetValues.totalWin = totalWin;
            targetValues.currentWin = currentWin;
            // Don't update total win if it's null
            if (totalWin !== null) {
                updateTotalWin();
            }
            updateCurrentWin();
        }
    }
}

const updateCurrentWin = () => {
    Components.betBar.setCurrentWin(tickingValues.currentWin);
};

const updateTotalWin = () => {
    Components.betBar.setTotalWin(tickingValues.totalWin);
    Components.betMenu.setTotalWin(tickingValues.totalWin);
};



// WEBPACK FOOTER //
// ./~/slotworks/commands/betbar/set-winnings-command.ts